
// const fun_aes = require('./aes.js')
import fun_aes from './aes'

//十六位十六进制数作为秘钥
var key = fun_aes.CryptoJS.enc.Utf8.parse("3692373874a57c45");
//十六位十六进制数作为秘钥偏移量
var iv = fun_aes.CryptoJS.enc.Utf8.parse('132336965f216e84');

function encrypt(word) {
  var srcs = fun_aes.CryptoJS.enc.Utf8.parse(word);
  var encrypted = fun_aes.CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: fun_aes.CryptoJS.mode.CBC,
    padding: fun_aes.CryptoJS.pad.Pkcs7
  });
  return encrypted.ciphertext.toString().toUpperCase();
}

function decrypt(word) {
  var encryptedHexStr = fun_aes.CryptoJS.enc.Hex.parse(word);
  var srcs = fun_aes.CryptoJS.enc.Base64.stringify(encryptedHexStr);
  var decrypt = fun_aes.CryptoJS.AES.decrypt(srcs, key, {
    iv: iv,
    mode: fun_aes.CryptoJS.mode.CBC,
    padding: fun_aes.CryptoJS.pad.Pkcs7
  });
  var decryptedStr = decrypt.toString(fun_aes.CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

function encode(obj) {
  let objJsonString = JSON.stringify(obj)
  //aes加密
  let str_aes_encode = this.encrypt(objJsonString)
  return str_aes_encode;
}

function decode(input) {
  //aes解密
  let str_aes_decode = this.decrypt(input);
  let decodeObj = JSON.parse(str_aes_decode)
  return decodeObj;
}

export default {
  encrypt: encrypt,
  decrypt: decrypt,
  encode: encode,
  decode: decode,
}